import { render, staticRenderFns } from "./ComoTeEnterasteNino.vue?vue&type=template&id=078cc971&scoped=true"
import script from "./ComoTeEnterasteNino.vue?vue&type=script&lang=js"
export * from "./ComoTeEnterasteNino.vue?vue&type=script&lang=js"
import style0 from "./ComoTeEnterasteNino.vue?vue&type=style&index=0&id=078cc971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078cc971",
  null
  
)

export default component.exports